import controller from './report-client-selector-controller';
import template from './report-client-selector.html'

const ReportClientSelectorComponent = {
    bindings: {
        buttonText: '<',
        clientList: '<',
        onButtonClick: '&',
        reportState: '<'
    },
    controller,
    template,
};

export default ReportClientSelectorComponent;



// WEBPACK FOOTER //
// ./app/common/report-client-selector/report-client-selector-component.js